export const EVENT_MOBILE_BREAKPOINT = 768;
export const EVENT_TABLET_BREAKPOINT = 1000;

export const INITIAL_EVENT_FILTER = {
    limit: 10,
    page: 1,
    sort: 'desc-id',
    search: '',
};

export const EVENT_TYPES = {
    walks: 'walks',
    groupWalks: 'group-walks',
};

export const EVENT_JOIN_BUTTON_STYLE = {
    background: 'linear-gradient(90deg, #ff4d6d 0%, #ff6a88 100%)',
    border: 'none',
    borderRadius: 999,
    padding: '0 15px',
    height: 24,
    fontWeight: 600,
    fontSize: 12,
    color: "#FFF"
};

export const EVENT_BANNER_STYLES = {
    content: {
        height: '200px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: '#d5e8eb',
        borderRadius: '8px',
        paddingBlock: '25px',
        paddingInline: '50px',
    },
    title: {
        textTransform: 'uppercase',
        color: '#2e2525ff',
        fontWeight: '600',
        fontSize: '40px',
    },
    breadcrumb: {
        fontSize: '20px',
        fontWeight: '500',
    },
};
